export default __webpack_public_path__ + "static/media/DNo.25-8.783007ba.jpg";